module.exports = __webpack_public_path__ + "static/media/checkimg.7cfb924a.svg";